<template>
  <div class='p-learning-detail c-parts-box' v-show='isActive'>
    <div class="switchingNav">
      <div class="switchingNav__item">
        <div class="c-form">
          <div class="c-form-select -status">
            <div class="output" @click="toggle()" ref="refOutput" name="S5-2-period-toggle-btn">
              <div class="label" v-if="currentDateTab === 'weeks' && selectedWeek !== null">
                <span class="year">{{selectedWeek.year}}</span>年<span class="num">{{selectedWeek.begin.month}}</span>月<span class="num">{{selectedWeek.begin.day}}</span>日-<span class="num">{{selectedWeek.end.month}}</span>月<span class="num">{{selectedWeek.end.day}}</span>日
              </div>
              <div class="label" v-else-if="currentDateTab === 'months' && selectedMonth !== null">
                <span class="year">{{selectedMonth.year}}</span>年<span class="num">{{selectedMonth.month}}</span>月
              </div>
              <div class="label" v-else-if="currentDateTab === 'years' && selectedYear !== null">
                <span class="year">{{selectedYear.year}}</span>年
              </div>
              <div class="label" v-else></div>
              <div class="arrow" ref="refArrow"></div>
            </div>
            <div class="option" ref="refSelectListBox">
              <ul class="option__list">
                <li v-for="(item, index) in daysRange[currentDateTab]"
                    @click="selectDate(item)" :key="index" name="S5-2-period-btn">
                  <span class="label" v-if="currentDateTab === 'weeks'">
                    <span class="year">{{item.year}}</span>年<span class="num">{{item.begin.month}}</span>月<span class="num">{{item.begin.day}}</span>日-<span class="num">{{item.end.month}}</span>月<span class="num">{{item.end.day}}</span>日
                  </span>
                  <span v-else-if="currentDateTab === 'months'">
                    <span class="year">{{item.year}}</span>年<span class="num">{{item.month}}</span>月
                  </span>
                  <span v-else>
                    <span class="year">{{item.year}}</span>年
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="switchingNav__item">
        <ul class="c-form-tab">
          <li :class="{'current': currentDateTab==='weeks'}">
            <a href="javascript:void(0);" @click="clickDate('weeks')" name="S5-2-week-period-btn">週間</a>
          </li>
          <li :class="{'current': currentDateTab==='months'}">
            <a href="javascript:void(0);" @click="clickDate('months')" name="S5-2-month-period-btn">月間</a>
          </li>
          <li :class="{'current': currentDateTab==='years'}">
            <a href="javascript:void(0);" @click="clickDate('years')" name="S5-2-year-period-btn">年間</a>
          </li>
        </ul>
      </div>
      <div class="switchingNav__item">
        <div class="toggleBtn">
          <p class="toggleBtn__title">学級平均</p>
          <div :class="{'c-parts-toggle':true,'c-parts-toggle--active': mySwitch, 'c-parts-toggle--avg_disabled': avg_disabled}" @click="toggleSwitch()" name="S5-2-average-toggle-btn">
            <span class="label">{{mySwitch?'ON':'OFF'}}</span>
            <span class="toggle"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="p-learning-detail-content">
      <div class="p-learning-detail-content__inner">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconClock"></span>学習時間
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li>累計<span class="num">{{Math.floor(totalSummary.total_study_minutes/60)}}</span><span class="unit">時間</span>
              <span class="num">{{totalSummary.total_study_minutes%60}}</span><span class="unit">分</span>
            </li>
            <li>学級平均<span class="graph__line"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <template v-if="currentDateTab==='weeks'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{getHours(detailByWeek)}}</span>時間<span class="num">{{getMinutes(detailByWeek)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByWeek)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByWeek)}">{{getDiffHours(detailByWeek)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByWeek)}">{{getDiffMinutes(detailByWeek)}}</span>分)
                </div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='months'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{getHours(detailByMonth)}}</span>時間<span class="num">{{getMinutes(detailByMonth)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByMonth)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByMonth)}">{{getDiffHours(detailByMonth)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByMonth)}">{{getDiffMinutes(detailByMonth)}}</span>分)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='years'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{getHours(detailByYear)}}</span>時間<span class="num">{{getMinutes(detailByYear)}}</span>分勉強しました(前の期間より<span class="symbol--minus" v-if="isMinus(detailByYear)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinus(detailByYear)}">{{getDiffHours(detailByYear)}}</span>時間<span :class="{num: true, 'num--minus': isMinus(detailByYear)}">{{getDiffMinutes(detailByYear)}}</span>分)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <div class="p-learning-detailFigure p-learning-detailFigure--block">
            <p class="ChartUnit">（時間）</p>
            <line-chart :chartData="lineChartDatas" name="timeLineChart"></line-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="p-learning-detail-content">
      <div class="p-learning-detail-content__inner p-learning-detail-content__inner--small">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconStar"></span>獲得スター数
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li>累計<span class="num">{{totalSummary.total_number_of_stars}}</span><span class="unit">個</span></li>
            <li>学級平均<span class="graph__bar"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <template v-if="currentDateTab==='weeks'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByWeek.number_of_stars}}</span>個獲得しました<br>(前の期間より<span class="symbol--minus" v-if="isMinusStar(detailByWeek)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusStar(detailByWeek)}">{{Math.abs(detailByWeek.number_of_stars - detailByWeek.number_of_stars_previous)}}</span>個)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='months'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByMonth.number_of_stars}}</span>個獲得しました<br>(前の期間より<span class="symbol--minus" v-if="isMinusStar(detailByMonth)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusStar(detailByMonth)}">{{Math.abs(detailByMonth.number_of_stars - detailByMonth.number_of_stars_previous)}}</span>個)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='years'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByYear.number_of_stars}}</span>個獲得しました<br>(前の期間より<span class="symbol--minus" v-if="isMinusStar(detailByYear)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusStar(detailByYear)}">{{Math.abs(detailByYear.number_of_stars - detailByYear.number_of_stars_previous)}}</span>個)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <div class="p-learning-detailFigure p-learning-detailFigure--wrap">
            <p class="ChartUnit">（個）</p>
            <bar-chart :chartData="starBarChartDatas" unit="個" name="starBarChart"></bar-chart>
          </div>
        </div>
        <div class="p-learning-detail-content__footer">
          <p v-if="hidden">あと<span class="num">10</span>個でバッジ獲得！</p>
          <router-link :to="{ name: 'top' }" class="c-button-white -flag" @click.native="selectedCurrentMission"><span class="label">ミッションを取り組む</span></router-link>
        </div>
      </div>

      <div class="p-learning-detail-content__inner p-learning-detail-content__inner--small">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconFlag"></span>クリアミッション数
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li>累計<span class="num">{{totalSummary.total_cleared_missions}}</span><span class="unit">回</span></li>
            <li>学級平均<span class="graph__bar"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <template v-if="currentDateTab==='weeks'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByWeek.cleared_missions}}</span>回クリアしました<br>(前の期間より<span class="symbol--minus" v-if="isMinusMission(detailByWeek)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusMission(detailByWeek)}">{{Math.abs(detailByWeek.cleared_missions - detailByWeek.cleared_missions_previous)}}</span>回)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='months'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByMonth.cleared_missions}}</span>回クリアしました<br>(前の期間より<span class="symbol--minus" v-if="isMinusMission(detailByMonth)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusMission(detailByMonth)}">{{Math.abs(detailByMonth.cleared_missions - detailByMonth.cleared_missions_previous)}}</span>回)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <template v-if="currentDateTab==='years'">
            <div class="speechBubble">
              <div class="speechBubble__inner">
                <div class="label">この期間は<span class="num">{{detailByYear.cleared_missions}}</span>回クリアしました<br>(前の期間より<span class="symbol--minus" v-if="isMinusMission(detailByYear)">-</span><span class="symbol" v-else>＋</span><span :class="{num: true, 'num--minus': isMinusMission(detailByYear)}">{{Math.abs(detailByYear.cleared_missions - detailByYear.cleared_missions_previous)}}</span>回)</div>
                <div class="speechBubble__arrow"></div>
              </div>
            </div>
          </template>
          <div class="p-learning-detailFigure p-learning-detailFigure--wrap">
            <p class="ChartUnit">（回）</p>
            <bar-chart :chartData="missionBarChartDatas" unit="回" name="missionBarChart"></bar-chart>
          </div>
        </div>
        <div class="p-learning-detail-content__footer">
          <p v-if="hidden">あと<span class="num">10</span>回でバッジ獲得！</p>
          <router-link :to="{ name: 'top' }" class="c-button-white -flag" @click.native="selectedCurrentMission"><span class="label">ミッションを取り組む</span></router-link>
        </div>
      </div>
    </div>

    <div class="p-learning-detail-content" v-if="!isAll">
      <div class="p-learning-detail-content__inner">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconLearning"></span>学習実施状況
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li><span class="num">{{learningProgress.answered_rate}}</span><span class="unit">%</span><span class="all">(<span class="num">{{learningProgress.number_of_answered}}</span>問/全<span class="num">{{learningProgress.number_of_all_questions}}</span>問）</span></li>
            <li>学級平均<span class="graph__bar"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <div class="p-learning-detailFigure">
            <div class="figureBarHorizontal">
              <div class="chart">
                <ul class="chart__scale">
                  <li class="item"><span class="item__num">0</span></li>
                  <li class="item"><span class="item__num">10</span></li>
                  <li class="item"><span class="item__num">20</span></li>
                  <li class="item"><span class="item__num">30</span></li>
                  <li class="item"><span class="item__num">40</span></li>
                  <li class="item"><span class="item__num">50</span></li>
                  <li class="item"><span class="item__num">60</span></li>
                  <li class="item"><span class="item__num">70</span></li>
                  <li class="item"><span class="item__num">80</span></li>
                  <li class="item"><span class="item__num">90</span></li>
                  <li class="item"><span class="item__num"><span class="unit unit--percent">100</span></span></li>
                </ul>
                <ul class="chart__bar">
                  <li class="item item--fillBar">
                    <div class="item__fill" :style="{width: learningProgress.answered_rate + '%'}"><span :class="{num: true, 'num--outsize': learningProgress.answered_rate<90}">{{learningProgress.answered_rate}}</span></div>
                  </li>
                  <li class="item item--fillBar item--average" v-if="mySwitch">
                    <div class="item__fill" :style="{width: classroomAverageLearningProgress.answered_rate + '%'}"><span :class="{num: true,  'num--outsize': classroomAverageLearningProgress.answered_rate<90}">{{classroomAverageLearningProgress.answered_rate}}</span></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul class="badge-container" v-if="hidden">
            <li class="clear">
            </li>
            <li class="clear">
              <div class="badge"><div class="badge__marker on">バッジ</div></div>
              <span class="num">10月10日</span>取得
            </li>
            <li class="clear">
              <div class="badge"><div class="badge__marker on">バッジ</div></div>
              <span class="num">10月10日</span>取得
            </li>
            <li class="clear">
            </li>
            <li class="clear">
            </li>
            <li class="clear">
              <div class="badge"><div class="badge__marker">バッジ</div></div>
            </li>
            <li class="clear">
            </li>
            <li class="clear">
            </li>
            <li class="clear">
            </li>
            <li class="clear">
            </li>
            <li class="clear">
              <div class="badge"><div class="badge__marker">バッジ</div></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="p-learning-detail-content">
      <div class="p-learning-detail-content__inner">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconAnswer"></span>正答率
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li><span class="num">{{correctAnswerRate.latest_correct_answer_rate}}</span><span class="unit">%</span><span class="all">(<span class="num">{{correctAnswerRate.number_of_correct_answered}}</span>問/全<span class="num">{{correctAnswerRate.number_of_answered}}</span>問）</span></li>
            <li>初回<span class="graph__bar graph__bar--color1"></span></li>
            <li>最新<span class="graph__bar graph__bar--color2"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <div v-if="displayCorrectAnswerRateStatus" class="speechBubble">
            <div class="speechBubble__inner">
              <div class="label">正答率が<span class="num">{{correctAnswerRate.latest_correct_answer_rate - correctAnswerRate.first_time_correct_answer_rate}}</span><span class="unit">%</span>上がりました！</div>
              <div class="speechBubble__arrow"></div>
            </div>
          </div>
          <div class="p-learning-detailFigure">
            <div class="figureBarHorizontal">
              <div class="chart">
                <ul class="chart__scale">
                  <li class="item"><span class="item__num">0</span></li>
                  <li class="item"><span class="item__num">10</span></li>
                  <li class="item"><span class="item__num">20</span></li>
                  <li class="item"><span class="item__num">30</span></li>
                  <li class="item"><span class="item__num">40</span></li>
                  <li class="item"><span class="item__num">50</span></li>
                  <li class="item"><span class="item__num">60</span></li>
                  <li class="item"><span class="item__num">70</span></li>
                  <li class="item"><span class="item__num">80</span></li>
                  <li class="item"><span class="item__num">90</span></li>
                  <li class="item"><span class="item__num"><span class="unit unit--percent">100</span></span></li>
                </ul>
                <ul class="chart__bar">
                  <li class="item item--addBar">
                    <div class="item__fill" :style="{width: correctAnswerRate.first_time_correct_answer_rate + '%'}"><span :class="{num: true, 'num--outsize': correctAnswerRate.first_time_correct_answer_rate<90}">{{correctAnswerRate.first_time_correct_answer_rate}}</span></div>
                  </li>
                  <li class="item item--addBar item--latest">
                    <div class="item__fill" :style="{width: correctAnswerRate.latest_correct_answer_rate + '%'}"><span :class="{num: true, 'num--outsize': correctAnswerRate.latest_correct_answer_rate<90}">{{correctAnswerRate.latest_correct_answer_rate}}</span></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-learning-detail-content" v-if="!isAll && mySwitch">
      <div class="p-learning-detail-content__inner">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconAnswer"></span>学級の平均正答率
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li><span class="num">{{classroomAverageCorrectAnswerRate.latest_correct_answer_rate}}</span><span class="unit">%</span><span class="all">(<span class="num">{{classroomAverageCorrectAnswerRate.number_of_correct_answered}}</span>問/全<span class="num">{{classroomAverageCorrectAnswerRate.number_of_answered}}</span>問）</span></li>
            <li>初回<span class="graph__bar graph__bar--color3"></span></li>
            <li>最新<span class="graph__bar"></span></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <div class="p-learning-detailFigure">
            <div class="figureBarHorizontal">
              <div class="chart">
                <ul class="chart__scale">
                  <li class="item"><span class="item__num">0</span></li>
                  <li class="item"><span class="item__num">10</span></li>
                  <li class="item"><span class="item__num">20</span></li>
                  <li class="item"><span class="item__num">30</span></li>
                  <li class="item"><span class="item__num">40</span></li>
                  <li class="item"><span class="item__num">50</span></li>
                  <li class="item"><span class="item__num">60</span></li>
                  <li class="item"><span class="item__num">70</span></li>
                  <li class="item"><span class="item__num">80</span></li>
                  <li class="item"><span class="item__num">90</span></li>
                  <li class="item"><span class="item__num"><span class="unit unit--percent">100</span></span></li>
                </ul>
                <ul class="chart__bar">
                  <li class="item item--addBar item--latest2">
                    <div class="item__fill" :style="{width: classroomAverageCorrectAnswerRate.first_time_correct_answer_rate + '%'}"><span :class="{num: true, 'num--outsize': classroomAverageCorrectAnswerRate.first_time_correct_answer_rate<90}">{{classroomAverageCorrectAnswerRate.first_time_correct_answer_rate}}</span></div>
                  </li>
                  <li class="item item--addBar item--average">
                    <div class="item__fill" :style="{width: classroomAverageCorrectAnswerRate.latest_correct_answer_rate + '%'}"><span :class="{num: true, 'num--outsize': classroomAverageCorrectAnswerRate.latest_correct_answer_rate<90}">{{classroomAverageCorrectAnswerRate.latest_correct_answer_rate}}</span></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-learning-detail-content" v-if="!isAll">
      <div class="p-learning-detail-content__inner">
        <div class="p-learning-detail-content__head">
          <div class="p-learning-detail-content__head__title">
            <span class="iconLearning"></span>スキル別正答率
          </div>
          <ul class="p-learning-detail-content__head__data">
            <li></li>
          </ul>
        </div>
        <div class="p-learning-detail-content__main">
          <ul class="p-learning-detail-content__main__data">
            <li>初回学習<span class="graph__rader graph__rader--color1"></span></li>
            <li>最新学習<span class="graph__rader graph__rader--color2"></span></li>
            <li>学級平均（最新）<span class="graph__rader graph__rader--color3"></span></li>
          </ul>
          <div class="p-learning-detailFigure">
            <radar-chart :chartData="radarChartDatas" name="skillRadarChart"></radar-chart>
            <div class="p-learning-detailFigure__side">
              <div class="p-learning-detailFigure__table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>初回学習</th>
                      <th>最新学習</th>
                      <th v-if="mySwitch">学級平均<br>（最新）</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in correctAnswerRateBySkill">
                      <th>{{item.name}}</th>
                      <td><span class="num">{{item.first_time_correct_answer_rate}}</span><span class="unit">%</span></td>
                      <td>
                        <span class="num">{{item.latest_correct_answer_rate}}</span><span class="unit">%</span>
                        <div class="comparison comparison--up" v-if="(item.latest_correct_answer_rate - item.first_time_correct_answer_rate)>0">
                          <span class="iconComparisonUp"></span>+<span class="num">{{item.latest_correct_answer_rate - item.first_time_correct_answer_rate}}</span><span class="unit">%</span>
                        </div>
                        <div class="comparison comparison--down" v-else-if="(item.latest_correct_answer_rate - item.first_time_correct_answer_rate)<0">
                          <span class="iconComparisonDown"></span>-<span class="num">{{item.first_time_correct_answer_rate - item.latest_correct_answer_rate}}</span><span class="unit">%</span>
                        </div>
                      </td>
                      <td v-if="mySwitch"><span class="num">{{classroomAverageCorrectAnswerRateBySkill[idx]?classroomAverageCorrectAnswerRateBySkill[idx].latest_correct_answer_rate:0}}</span><span class="unit">%</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, onUnmounted, nextTick, computed, watch} from 'vue';
  import {SUBJECT_MAP, SUBJECTFIELD_MAP, SOCIETY_SUBJECT_FIELD, SUBJECTFIELD_SORT_MAP} from "@/consts/subject";
  import LineChart from "@/components/student/LineChart.vue"
  import BarChart from "@/components/student/BarChart.vue"
  import RadarChart from "@/components/student/RadarChart.vue"
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useTopStore } from '@/store/student/top_store';
  import { useLearningStatusDetailStore } from '@/store/student/learning_status_detail_store';

  const globalNavigationStore = useGlobalNavigationStore()
  const topStore = useTopStore()
  const learningStatusDetailStore = useLearningStatusDetailStore()
  const refOutput = ref(null)
  const refArrow = ref(null)
  const refSelectListBox = ref(null)
  const hidden = ref(false); // Release 1 hidden
  const isActive = ref(false);
  const currentDateTab = ref("weeks");
  const mySwitch = ref(false);
  const isVisible = ref(false);
  const zIndex = ref(10);
  const selectedWeek = ref(null);
  const selectedMonth = ref(null);
  const selectedYear = ref(null);
  const daysRange = ref<any>({});
  const totalSummary = ref({
    total_cleared_missions: 0,
    total_number_of_stars: 0,
    total_study_minutes: 0
  });
  const detailByWeek = ref({
    cleared_missions: 0,
    cleared_missions_previous: 0,
    number_of_stars: 0,
    number_of_stars_previous: 0,
    study_minutes: 0,
    study_minutes_previous: 0,
    daily_data: []
  });
  const detailByMonth = ref({
    cleared_missions: 0,
    cleared_missions_previous: 0,
    number_of_stars: 0,
    number_of_stars_previous: 0,
    study_minutes: 0,
    study_minutes_previous: 0,
    weekly_data: []
  });
  const detailByYear = ref({
    cleared_missions: 0,
    cleared_missions_previous: 0,
    number_of_stars: 0,
    number_of_stars_previous: 0,
    study_minutes: 0,
    study_minutes_previous: 0,
    monthly_data: []
  });
  const classroomAverageByWeek = ref({daily_data: []});
  const classroomAverageByMonth = ref({weekly_data: []});
  const classroomAverageByYear = ref({monthly_data: []});
  const learningProgress = ref({
    number_of_answered: 0,
    number_of_all_questions: 0,
    answered_rate: 0
  });
  const classroomAverageLearningProgress = ref({
    number_of_answered: 0,
    number_of_all_questions: 0,
    answered_rate: 0
  });
  const correctAnswerRate = ref({
    number_of_answered: 0,
    number_of_correct_answered: 0,
    first_time_correct_answer_rate: 0,
    latest_correct_answer_rate: 0
  });
  const classroomAverageCorrectAnswerRate = ref({
    number_of_answered: 0,
    number_of_correct_answered: 0,
    first_time_correct_answer_rate: 0,
    latest_correct_answer_rate: 0
  });
  const correctAnswerRateBySkill = ref([]);
  const classroomAverageCorrectAnswerRateBySkill = ref([]);
  const isCalled = ref(true)
  const lineChartDatas = ref<any>({})
  const starBarChartDatas = ref<any>({})
  const missionBarChartDatas = ref<any>({})
  const radarChartDatas = ref<any>({})
  const avg_disabled = ref(false)
  const props = withDefaults(
    defineProps<{
      title: string;
      name: string;
      isAll?: boolean;
    }>(),
    {
      isAll: false,
    }
  );

  onMounted(async() => {
    if(props.isAll){
      daysRange.value = await learningStatusDetailStore.fetchDaysRange({subject_field: null});
      totalSummary.value = await learningStatusDetailStore.fetchDetailTotalSummary({subject_field: null});
      await selectDate(daysRange.value[currentDateTab.value][0])
      generateChartData()
    }
    window.addEventListener('click', closeDropdown)
  })
  const getCurrentYear = computed(() => {
    const current_date: Date = new Date()
    if (0 <= current_date.getMonth()  && current_date.getMonth() < 3) {
      return current_date.getFullYear() - 1
    }
    return current_date.getFullYear()
  })
  
  function closeDropdown(e){
    if(!(refOutput.value == e.target || refArrow.value == e.target)){
      toggle(true)
    }
  }
  onUnmounted(() => {
    window.removeEventListener('click', closeDropdown)
  })
  // NFR-3602 0%の場合は「正答率がx％あがりました」表示しない。
  const displayCorrectAnswerRateStatus = computed(() => {
    let result = correctAnswerRate.value.latest_correct_answer_rate - correctAnswerRate.value.first_time_correct_answer_rate
    if(result > 0){
      return true
    }else{
      return false
    }
  })
  // 「総合」以外の教科タブを押した時、行う処理。
  async function firstTimeCallApi(){
    if(isCalled.value){
      daysRange.value = await learningStatusDetailStore.fetchDaysRange({subject_field: props.title});
      totalSummary.value = await learningStatusDetailStore.fetchDetailTotalSummary({subject_field: props.title});
      classroomAverageLearningProgress.value = await learningStatusDetailStore.fetchClassroomAverageLearningProgress({subject_field: props.title});
      classroomAverageCorrectAnswerRate.value = await learningStatusDetailStore.fetchClassroomAverageCorrectAnswerRate({subject_field: props.title});
      classroomAverageCorrectAnswerRateBySkill.value = await learningStatusDetailStore.fetchClassroomAverageCorrectAnswerRateBySkill({subject_field: props.title});
      await selectDate(daysRange.value[currentDateTab.value][0])
    }
    generateChartData()
    radarChartDatas.value = radarChartData()
  }

  function generateChartData() {
    lineChartDatas.value = lineChartData()
    starBarChartDatas.value = starBarChartData()
    missionBarChartDatas.value = missionBarChartData()
  }

  function lineChartData(){
    let datasets: Array<any> = [];
    let labels: Array<any> = ['',];
    let data: Array<any> = [null,];
    let avgData: Array<any> = [null,];
    if(currentDateTab.value == "weeks"){
      detailByWeek.value.daily_data.forEach(item => {
        let weekday = new Date(item.year, item.month-1, item.day).toLocaleDateString("ja-JP", {weekday: "short"})
        labels.push(`${item.month}/${item.day}(${weekday})`)
        if(item.study_minutes == null){
          data.push(`${item.study_minutes}`)
        }else{
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByWeek.value.daily_data.forEach(item => {
        if(item.study_minutes == null){
          avgData.push(`${item.study_minutes}`)
        }else{
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    }else if(currentDateTab.value == "months"){
      detailByMonth.value.weekly_data.forEach((item, index) => {
        labels.push(`${item.begin.month}月${index+1}週`)
        if(item.study_minutes == null){
          data.push(`${item.study_minutes}`)
        }else{
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByMonth.value.weekly_data.forEach(item => {
        if(item.study_minutes == null){
          avgData.push(`${item.study_minutes}`)
        }else{
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    }else{
      detailByYear.value.monthly_data.forEach(item => {
        labels.push(`${item.month}月`)
        if(item.study_minutes == null){
          data.push(`${item.study_minutes}`)
        }else{
          data.push(`${item.study_minutes/60}`)
        }
      })
      classroomAverageByYear.value.monthly_data.forEach(item => {
        if(item.study_minutes == null){
          avgData.push(`${item.study_minutes}`)
        }else{
          avgData.push(`${item.study_minutes/60}`)
        }
      })
    }
    labels.push('')
    data.push(null)
    avgData.push(null)
    datasets.push({
      label: '学習時間',
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "rgba(41, 101, 247, 1)",
      data: data,
      lineTension: 0,
      borderWidth: 4,
      pointBackgroundColor: "rgba(41, 101, 247, 1)",
      pointBorderColor: "rgba(255, 255, 255, 1)",
      pointHoverBorderColor: "rgba(255, 255, 255, 1)",
      pointBorderWidth: 4,
      pointRadius: 8,
      pointHoverRadius: 8,
      pointHitRadius: 4,
    })
    if(mySwitch.value){
      datasets.push({
        label: '学級平均',
          data: avgData,
          borderColor: "rgba(204, 204, 204, 1)",
          backgroundColor: "rgba(0,0,0,0)",
          lineTension: 0,
          borderWidth: 3,
          pointBackgroundColor: "rgba(204, 204, 204, 1)",
          pointBorderColor: "rgba(255, 255, 255, 1)",
          pointHoverBorderColor: "rgba(255, 255, 255, 1)",
          pointBorderWidth: 4,
          pointRadius: 8,
          pointHoverRadius: 8,
          pointHitRadius: 4,
      })
    }
    return {labels: labels, datasets: datasets}
  }

  function starBarChartData(){
    let datasets: Array<any> = []
    let labels: Array<any> = []
    let data: Array<any> = []
    let avgData: Array<any> = []
    if(currentDateTab.value == "weeks"){
      detailByWeek.value.daily_data.forEach(item => {
        labels.push(`${item.month}/${item.day}`)
        data.push(`${item.number_of_stars}`)
      })
      classroomAverageByWeek.value.daily_data.forEach(item => avgData.push(`${item.number_of_stars}`))
    }else if(currentDateTab.value == "months"){
      detailByMonth.value.weekly_data.forEach((item, index) => {
        labels.push(`${index+1}週`)
        data.push(`${item.number_of_stars}`)
      })
      classroomAverageByMonth.value.weekly_data.forEach(item => avgData.push(`${item.number_of_stars}`))
    }else{
      detailByYear.value.monthly_data.forEach(item => {
        labels.push(`${item.month}`)
        data.push(`${item.number_of_stars}`)
      })
      classroomAverageByYear.value.monthly_data.forEach(item => avgData.push(`${item.number_of_stars}`))
    }
    datasets.push({
      label: '獲得数',
      backgroundColor: "rgba(41, 101, 247, 1)",
      data: data
    })
    if(mySwitch.value){
      datasets.push({
        label: '学級平均',
        data: avgData,
        backgroundColor: "rgba(204, 204, 204, 1)",
      })
    }
    return {labels: labels, datasets: datasets}
  }


  function missionBarChartData(){
    let datasets: Array<any> = [];
    let labels: Array<any> = [];
    let data: Array<any> = [];
    let avgData: Array<any> = [];
    if(currentDateTab.value == "weeks"){
      detailByWeek.value.daily_data.forEach(item => {
        labels.push(`${item.month}/${item.day}`)
        data.push(`${item.cleared_missions}`)
      });
      classroomAverageByWeek.value.daily_data.forEach(item => avgData.push(`${item.cleared_missions}`));
    }else if(currentDateTab.value == "months"){
      detailByMonth.value.weekly_data.forEach((item, index) => {
        labels.push(`${index+1}週`)
        data.push(`${item.cleared_missions}`)
      });
      classroomAverageByMonth.value.weekly_data.forEach(item => avgData.push(`${item.cleared_missions}`));
    }else{
      detailByYear.value.monthly_data.forEach(item => {
        labels.push(`${item.month}`)
        data.push(`${item.cleared_missions}`)
      });
      classroomAverageByYear.value.monthly_data.forEach(item => avgData.push(`${item.cleared_missions}`));
    }
    datasets.push({
      label: 'クリア数',
      backgroundColor: "rgba(41, 101, 247, 1)",
      data: data
    });
    if(mySwitch.value){
      datasets.push({
        label: '学級平均',
        data: avgData,
        backgroundColor: "rgba(204, 204, 204, 1)",
      })
    }
    return {labels: labels, datasets: datasets};
  }

  function radarChartData(){
    let labels: Array<string> = []
    let latest_data: Array<number> = []
    let first_data: Array<number> = []
    let avg_data: Array<number> = []
    correctAnswerRateBySkill.value.forEach((item, index) => {
      labels.push(item.name)
      latest_data.push(item.latest_correct_answer_rate)
      first_data.push(item.first_time_correct_answer_rate)
      if(classroomAverageCorrectAnswerRateBySkill.value[index]){
        avg_data.push(classroomAverageCorrectAnswerRateBySkill.value[index].latest_correct_answer_rate)
      }
    })
    let datasets:Array<any> = [
      {
        label: '初回学習',
        data: first_data,
        backgroundColor: 'rgba(41, 101, 247, 0.5)',
        borderColor: 'rgba(41, 101, 247, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(0, 0, 0, 0)',
        pointBackgroundColor: 'rgba(0, 0, 0, 0)'
      },
      {
        label: '最新学習',
        data: latest_data,
        backgroundColor: 'rgba(148, 178, 251, 0.5)',
        borderColor: 'rgba(148, 178, 251, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(0, 0, 0, 0)',
        pointBackgroundColor: 'rgba(0, 0, 0, 0)'
      }
    ]
    if(mySwitch.value){
      datasets.push({
        label: '最新学習の学級平均',
        data: avg_data,
        backgroundColor: 'rgba(196, 196, 196, 0.5)',
        borderColor: 'rgba(196, 196, 196, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(0, 0, 0, 0)',
        pointBackgroundColor: 'rgba(0, 0, 0, 0)'
      })
    }
    return {labels: labels, datasets: datasets}
  }

  // 「週間」「月間」「年間」ボタンを選択する時、行う処理。
  async function clickDate(name){
    // 既に選択した期間ボタンをまた押した時は何もせずにreturnする。
    if(currentDateTab.value == name){
      return;
    }
    currentDateTab.value = name;
    // NFR-5290 daysRange.value[currentDateTab.value]がundefinedであれば何もせずにreturnする
    if (!daysRange.value[currentDateTab.value]){
      return;
    }
    await selectDate(daysRange.value[currentDateTab.value][0])
  }
  function toggle(isVisibleLocal=false){
    if(isVisibleLocal){
      isVisible.value = false
    }
    else{
      isVisible.value = !isVisible.value;
    }
    if (refOutput.value && refSelectListBox.value){
      if(isVisible.value){
        refOutput.value.style.zIndex = zIndex.value;
        refSelectListBox.value.style.display = "block";
        refSelectListBox.value.style.opacity = 1;
        zIndex.value++;
      }
      else{
        refOutput.value.style.zIndex = 0;
        refSelectListBox.value.style.display = "none";
        refSelectListBox.value.style.opacity = 0;
      }
    }
  }
  function getYear(year:number, month:number) {
    if(month >= 1 && month <= 3) {
      return year - 1
    }
    return year
  }
  async function selectDate(item:{year: number, month?: number, begin?:any, end?: any}){
    if(!item){
      return
    }
    let payload = {
      subject_field: props.isAll ? null : props.title,
      year: item.year
    };
    // 週間
    if(currentDateTab.value == "weeks"){
      const isMatch = getCurrentYear.value !== getYear(item.year, item.begin.month) && getCurrentYear.value !== getYear(item.year, item.end.month)
      // 学習した年度による学級平均トグル状態を設定する。
      setToggleStatusByCurrentYear(isMatch)
      selectedWeek.value = item;
      payload["month"] = item.begin.month;
      payload["day"] = item.begin.day;
      // 週間の学習詳細を取得する
      detailByWeek.value = await learningStatusDetailStore.fetchDetailByWeek(payload);
      if(mySwitch.value){ // 学級平均トグルがONの場合は週間の学級平均詳細を取得する。
        classroomAverageByWeek.value = await  learningStatusDetailStore.fetchClassroomAverageByWeek(payload);
      }
      // 選択されて期間の年と月を利用して学習した年度を取る。
      payload["year"] = getYear(item.year, item.begin.month)
      // 学習した年度によって学習実施状況、正答率、スキル別正答率履歴を取得する。
      await setLearningProgressByCurrentYear(payload)
    }
    // 月間
    else if(currentDateTab.value == "months"){
      const isMatch = getCurrentYear.value !== getYear(item.year, item.month)
      setToggleStatusByCurrentYear(isMatch)
      selectedMonth.value = item;
      payload["month"] = item.month;
      detailByMonth.value = await learningStatusDetailStore.fetchDetailByMonth(payload);
      if(mySwitch.value){
        classroomAverageByMonth.value = await  learningStatusDetailStore.fetchClassroomAverageByMonth(payload);
      }
      payload["year"] = getYear(item.year, item.month)
      await setLearningProgressByCurrentYear(payload)
    }
    // 年間
    else if(currentDateTab.value == "years"){
      const isMatch = getCurrentYear.value !== item.year
      setToggleStatusByCurrentYear(isMatch)
      selectedYear.value = item;
      detailByYear.value = await learningStatusDetailStore.fetchDetailByYear(payload);
      if(mySwitch.value){
        classroomAverageByYear.value = await learningStatusDetailStore.fetchClassroomAverageByYear(payload);
      }
      await setLearningProgressByCurrentYear(payload)
    }
    generateChartData()
    if(!props.isAll){ // 「総合」以外の場合、スキール別正答率チャートデータを選択した期間によって取得する。
      radarChartDatas.value = radarChartData()
    }
  }
  // 学習平均トグルボタンを押す時、行う処理。
  async function toggleSwitch(){
    mySwitch.value = !mySwitch.value
    if(mySwitch.value && (selectedWeek.value != null || selectedMonth.value != null || selectedYear.value !=null)){
      if(currentDateTab.value == "weeks"){
        classroomAverageByWeek.value = await  learningStatusDetailStore.fetchClassroomAverageByWeek({
          subject_field: props.isAll ? null : props.title,
          year: selectedWeek.value.year,
          month: selectedWeek.value.begin.month,
          day: selectedWeek.value.begin.day
        });
      }else if(currentDateTab.value == "months"){
        classroomAverageByMonth.value = await  learningStatusDetailStore.fetchClassroomAverageByMonth({
          subject_field: props.isAll ? null : props.title,
          year: selectedMonth.value.year,
          month: selectedMonth.value.month
        });
      }else if(currentDateTab.value == "years"){
        classroomAverageByYear.value = await  learningStatusDetailStore.fetchClassroomAverageByYear({
          subject_field: props.isAll ? null : props.title,
          year: selectedYear.value.year
        });
      }
    }
    generateChartData()
    radarChartDatas.value = radarChartData()
  }
  // 学習した年度による学級平均トグル状態を設定する。
  function setToggleStatusByCurrentYear(is_match){
    if(is_match){
      avg_disabled.value = true
    }else{
      avg_disabled.value = false
    }
  }
  // NFR-3930 学習した年度によって学習実施状況、正答率、スキル別正答率履歴を取得する。
  async function setLearningProgressByCurrentYear(payload){
    if(!props.isAll){ // 「総合」以外の場合、学習実施状況、スキル別正答率は表示する
      learningProgress.value = await learningStatusDetailStore.fetchLearningProgress(payload);
      correctAnswerRateBySkill.value = await learningStatusDetailStore.fetchCorrectAnswerRateBySkill(payload);
    }
    correctAnswerRate.value = await learningStatusDetailStore.fetchCorrectAnswerRate(payload);
  }
  function getHours(item){
    return Math.floor(item.study_minutes/60);
  }
  function getMinutes(item){
    return item.study_minutes%60;
  }
  function isMinus(item){
    return (item.study_minutes - item.study_minutes_previous) < 0;
  }
  function getDiffHours(item){
    return Math.floor(Math.abs(item.study_minutes - item.study_minutes_previous)/60);
  }
  function getDiffMinutes(item){
    return Math.abs(item.study_minutes - item.study_minutes_previous)%60;
  }
  function isMinusStar(item){
    return (item.number_of_stars - item.number_of_stars_previous) < 0;
  }
  function isMinusMission(item){
    return (item.cleared_missions - item.cleared_missions_previous) < 0;
  }
  async function selectedCurrentMission(){
    let min = 5
    if(props.isAll){
      let subject = globalNavigationStore.licensedSubject[0].name
      // if first subject is 社会
      if(subject == SOCIETY_SUBJECT_FIELD.SHAKAI){
        let subjects = globalNavigationStore.licensedSubject.filter(subj => subj.name == subject)
        for(let subject_field of subjects[0].subject_fields){
          if (SUBJECTFIELD_SORT_MAP[subject_field]<min){
            min = SUBJECTFIELD_SORT_MAP[subject_field]
            subject = subject_field
          }
        }
        topStore.saveCurrentMission(SUBJECTFIELD_MAP[subject])
      }else{
        topStore.saveCurrentMission(SUBJECT_MAP[subject])
      }
    }else{
      if(props.title==SOCIETY_SUBJECT_FIELD.SHAKAI){
        let subjects = globalNavigationStore.licensedSubject.filter(subj => subj.name == props.title)
        let subject = "地理"
        for(let subject_field of subjects[0].subject_fields){
          if (SUBJECTFIELD_SORT_MAP[subject_field]<min){
            min = SUBJECTFIELD_SORT_MAP[subject_field]
            subject = subject_field
          }
        }
        topStore.saveCurrentMission(SUBJECTFIELD_MAP[subject])
      }else{
        topStore.saveCurrentMission(props.name)
      }
    }
  }
  defineExpose({isActive, isCalled, props, firstTimeCallApi})
</script>
